<template>
  <div>
    <h3 class="h-title">纠纷解决</h3>
    <el-form class="e-form f-b" ref="cForm2" :model="cForm2" label-width="160px"  label-position="left">
      <el-form-item label="纠纷解决" prop="disputeResolution" :rules="[{required: true,message:'请选择',trigger:'change'}]">
        <el-select v-model="cForm2.disputeResolution" placeholder="请选择" style="width: 100%">
          <el-option label="是" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="纠纷解决机构" prop="disputeResolutionOrgOne" :rules="[{required: (!cForm2.disputeResolutionOrgOne || !cForm2.institutionObj),message:'请选择',trigger:'change'}]">
        <el-select v-model="cForm2.disputeResolutionOrgOne" placeholder="请选择" style="width: 40%">
          <el-option
            v-for="dict in iTypenOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
        <el-select v-model="cForm2.institutionObj" @change="setInstitution" value-key="nodeId" placeholder="请选择" style="width: 60%">
          <el-option
            v-for="dict in institutionOptions"
            :key="dict.nodeId"
            :label="dict.nodeName"
            :value="dict"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="公司名称">
        {{cForm2.submitName}}
      </el-form-item>
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
  name: "step2",
  props: ["active"],
  data() {
    return {
      butLoading: false,
      cForm2: {},
      iTypenOptions: [],
      institutionOptions: [],     
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
        businessType:'5', 
        status: '0'
      },
    }
  },
  watch: {
    active(newVal) {
        if(newVal == 2) {
          window.scrollTo(0,0);
          this.cForm2 = JSON.parse(sessionStorage.setpForm);   
          this.getInstitution()       
        } 
      }
    },
  methods: { 
    setInstitution(obj){
      this.cForm2.disputeResolutionOrgTwo = obj.nodeName
      this.cForm2.disputeResolutionNode = obj.nodeId 
    },
    getInstitution(){             
      this.$api.api.getDicts("xf_dispute_solve_institution").then(response => {
          this.iTypenOptions = response.data;
      }); 
      this.queryParams.nodeName = ''
      this.$api.api.nodeList({...this.queryParams,nodeType:'3',contractType: this.cForm2.contractType}).then(response => {
        if(response.code == 200){
          this.institutionOptions = response.rows 
          if(this.cForm2.disputeResolutionOrgTwo){
            this.$set(this.cForm2, 'institutionObj', {
              nodeName: this.cForm2.disputeResolutionOrgTwo,
              nodeId: this.cForm2.disputeResolutionNode
            })
          }
        }else {
          this.$message.error(response.msg);
        }      
      });
    },
    prev() {
      sessionStorage.setpForm = JSON.stringify(this.cForm2);
      this.$emit('prev')
    },
    cSubmitForm(type){
      if(type == '0'){                  
        this.butLoading = true;
        this.cForm2.status = '0'
        this.$api.consumer.addAndUpd(JSON.stringify(this.cForm2)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.go(-1);
          }     
        });
        
      }else{
        this.$refs["cForm2"].validate(valid => {
          if (valid) {
            sessionStorage.setpForm = JSON.stringify(this.cForm2);
            this.$emit('next');
          }else {
            this.$nextTick(() => {
              elFormErrorScrollIntoView()
            })
          }
        }) 
      }  
    },
  }
}
</script>
